import { JWTRole } from "@hackthenorth/north";

import { Route } from "src/shared/constants/route";
import { useUserContext } from "src/shared/contexts/UserContext";

export type RsvpStep = {
  title: string;
  path: string;
};

const HACKER_STEPS: RsvpStep[] = [
  { title: "Personal Information", path: Route.HACKER_PERSONAL },
  { title: "Travel", path: Route.HACKER_TRAVEL },
  { title: "Your Badge", path: Route.HACKER_BADGE },
  { title: "Event Information", path: Route.HACKER_EVENT },
  { title: "Career", path: Route.HACKER_CAREER },
  { title: "Directory Profile", path: Route.HACKER_PROFILE },
  { title: "Confirmation", path: Route.HACKER_CONFIRMATION },
];

const BADGE_STEPS: RsvpStep[] = [
  { title: "Personal Information", path: Route.HACKER_PERSONAL },
  { title: "Your Badge", path: Route.HACKER_BADGE },
  { title: "Confirmation", path: Route.HACKER_CONFIRMATION },
];

const VOLUNTEER_STEPS: RsvpStep[] = [
  { title: "Personal Information", path: Route.HACKER_PERSONAL },
  { title: "Confirmation", path: Route.HACKER_CONFIRMATION },
];

export const useRsvpFlow = () => {
  const { roles, isOrganizer } = useUserContext();
  const isHackerRole = roles.includes(JWTRole.HACKER);
  const isVolunteerRole = roles.includes(JWTRole.VOLUNTEER);
  const isSponsor = roles.includes(JWTRole.SPONSOR);
  const useBadgeFlow =
    isOrganizer || isSponsor || roles.includes(JWTRole.ORGANIZER);

  const isVolunteer = isVolunteerRole && !useBadgeFlow;
  const isHacker = isHackerRole && !useBadgeFlow && !isVolunteer;

  return {
    isHacker,
    isVolunteer,
    showBadgeInfo: useBadgeFlow || (isHackerRole && !isVolunteerRole),
    steps: isVolunteer
      ? VOLUNTEER_STEPS
      : useBadgeFlow || !isHackerRole
      ? BADGE_STEPS
      : HACKER_STEPS,
  };
};
